export default "__VITE_ASSET__Jk8wNm6P__"